import axios from "axios";
import { getStringValue } from "commons/storage";

const baseURL = window?.globalConfig?.api;
console.log(window?.globalConfig?.api);

const axiosInstance = axios.create(baseURL);

axiosInstance.interceptors.request.use(
  async (config) => {
    const token = getStringValue("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// axiosInstance.interceptors.response.use(
//   (response) => {
//     return response;
//   },

//   (error) => {

//     switch (error?.response?.status) {

//       // authentication (token related issues)
//       case 401: {
//         localStorage.clear();
//         window.location = "/";
//         return Promise.reject('ERROR 401')
//       }

//       // // forbidden (permission related issues)

//       // case 403: {

//       //   Logout();
//       //   return Promise.reject('ERROR 403')

//       // }

//       // // bad request
//       // case 400: {

//       //   return Promise.reject('ERROR 400')

//       // }

//       // // not found
//       // case 404: {

//       //   return Promise.reject('ERROR 404')

//       // }

//       // // conflict
//       // case 409: {

//       //   return Promise.reject('ERROR 409')

//       // }

//       // // unprocessable
//       // case 422: {

//       //   return Promise.reject('ERROR 422')

//       // }

//       // generic api error (server related) unexpected
//       default: {
//         console.log(error);
//         return Promise.reject(error);

//       }

//     }

//   },

// );

export default axiosInstance;
